import { ThemeEvents, CartAddEvent } from '@theme/events';

class CartFlash extends HTMLElement {
  /** @type {ReturnType<typeof setTimeout> | undefined} */
  #timeout = undefined;

  /** @type {Animation | undefined} */
  #collapseAnimation = undefined;

  connectedCallback() {
    document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate.bind(this));
    this.closest('dialog')?.addEventListener('close', () => this.#hideImmediate());
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate.bind(this));
  }

  /**
   * @param {CustomEvent} event
   */
  #onCartUpdate(event) {
    const isAddToCart = event instanceof CartAddEvent && !event.detail.data?.didError;
    if (isAddToCart) this.#show();
  }

  #show() {
    this.#collapseAnimation?.cancel();
    this.#collapseAnimation = undefined;
    this.hidden = false;
    clearTimeout(this.#timeout);
    this.#timeout = setTimeout(() => this.#hide(), 4000);
  }

  #hide() {
    const height = this.getBoundingClientRect().height;
    this.#collapseAnimation = this.animate(
      [
        { height: `${height}px`, paddingBlock: getComputedStyle(this).paddingBlock },
        { height: '0px', paddingBlock: '0px' },
      ],
      { duration: 300, easing: 'ease-in-out', fill: 'forwards' }
    );
    this.#collapseAnimation.addEventListener('finish', () => {
      this.hidden = true;
    });
  }

  #hideImmediate() {
    this.#collapseAnimation?.cancel();
    this.#collapseAnimation = undefined;
    clearTimeout(this.#timeout);
    this.hidden = true;
  }
}

customElements.define('cart-flash', CartFlash);
